import { render } from "./Svg.vue?vue&type=template&id=492f4474"
import script from "./Svg.vue?vue&type=script&lang=js"
export * from "./Svg.vue?vue&type=script&lang=js"

import "./Svg.vue?vue&type=style&index=0&id=492f4474&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__